import { Component, Fragment } from 'react';
import { postData, putData, getData } from "../../servicos/api";
import { isAdmin } from "../../servicos/auth";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form, FormGroup, Label, Input, Button, Card, CardHeader, CardBody, CardFooter, Row, Col } from 'reactstrap';
import Navbar from '../../Components/Navbar';
import Sidebar from '../../Components/Sidebar';
import ModalResponse from '../../Components/ModalResponse';
import Combobox from '../../Components/Combobox';
import { Link } from "react-router-dom";
import Switch from 'react-switch';
import MaskedInput from 'react-text-mask';

//REDUX
import { setLoaderShow, setResponseModal } from '../../reducers/index';
import { connect } from 'react-redux';

import { queryClient } from '../../utilidades/queryClient';

const Formulario = (props) => {
    let estabelecimento;
    if (props.data && props.data.estabelecimento_id !== undefined && props.data.estabelecimento_id !== null && props.listaEstabelecimentos.length > 0) {
        estabelecimento = props.listaEstabelecimentos.filter(function (elem, i, object) {
            return elem.value === props.data.estabelecimento_id;
        });
        if(estabelecimento[0] !== undefined){
            estabelecimento = { value: estabelecimento[0].value, label: estabelecimento[0].label };
        }
    }

    let endereco;
    if (props.data && props.data.endereco_id !== undefined && props.data.endereco_id !== null && props.listaEnderecos.length > 0) {
        endereco = props.listaEnderecos.filter(function (elem, i, object) {
            return elem.value === props.data.endereco_id;
        });
        if(endereco[0] !== undefined){
            endereco = { value: endereco[0].value, label: endereco[0].label };
        }
    }

    let dia_ideal;
    if (props.data && props.data.dia_ideal_id !== undefined && props.data.dia_ideal_id !== null && props.listaDiasIdeais.length > 0) {
        dia_ideal = props.listaDiasIdeais.filter(function (elem, i, object) {
            return elem.value === props.data.dia_ideal_id;
        });
        if(dia_ideal[0] !== undefined){
            dia_ideal = { value: dia_ideal[0].value, label: dia_ideal[0].label };
        }
    }

    let periodo_ideal;
    if (props.data && props.data.periodo_ideal_id !== undefined && props.data.periodo_ideal_id !== null && props.listaPeriodosIdeais.length > 0) {
        periodo_ideal = props.listaPeriodosIdeais.filter(function (elem, i, object) {
            return elem.value === props.data.periodo_ideal_id;
        });
        if(periodo_ideal[0] !== undefined){
            periodo_ideal = { value: periodo_ideal[0].value, label: periodo_ideal[0].label };
        }
    }

    let validarAdmin = Yup.object({
        nome: Yup.string()
            .max(200, 'O campo nome deverá ter no máximo 200 caracteres.')
            .required('O campo nome é obrigatório.')
            .trim(),
        endereco_id: Yup.object()
            .required('O campo endereço é obrigatório.'),
        numero: Yup.number()
            .required('O campo número é obrigatório.')
            .integer('O campo número deverá receber um número inteiro.'),
        complemento: Yup.string()
            .max(200, 'O campo complemento deverá ter no máximo 200 caracteres.')
            .nullable()
            .trim(),
        telefone_principal: Yup.string()
            .nullable()
            .trim(),
        telefone_secundario: Yup.string()
            .nullable()
            .trim(),
        dia_ideal: Yup.object()
            .nullable(),
        periodo_ideal: Yup.object()
            .nullable(),
        observacao: Yup.string()
            .nullable()
            .trim(),
        estabelecimento_id: Yup.object()
            .required('O campo estabelecimento é obrigatório.'),
    });

    let validarEstabelecimento = Yup.object({
        nome: Yup.string()
            .max(200, 'O campo nome deverá ter no máximo 200 caracteres.')
            .required('O campo nome é obrigatório.')
            .trim(),
        endereco_id: Yup.object()
            .required('O campo endereço é obrigatório.'),
        numero: Yup.number()
            .required('O campo número é obrigatório.')
            .integer('O campo número deverá receber um número inteiro.'),
        complemento: Yup.string()
            .max(200, 'O campo complemento deverá ter no máximo 200 caracteres.')
            .nullable()
            .trim(),
        telefone_principal: Yup.string()
            .nullable()
            .trim(),
        telefone_secundario: Yup.string()
            .nullable()
            .trim(),
        dia_ideal: Yup.object()
            .nullable(),
        periodo_ideal: Yup.object()
            .nullable(),
        observacao: Yup.string()
            .nullable()
            .trim(),
    });

    const formik = useFormik({
        initialValues: {
            nome:                props.data !== undefined && props.data !== null ? props.data.nome : '',
            telefone_principal:  props.data !== undefined && props.data !== null ? props.data.telefone_principal : '',
            telefone_secundario: props.data !== undefined && props.data !== null ? props.data.telefone_secundario : '',
            dia_ideal:           props.data !== undefined && props.data !== null ? props.data.dia_ideal : '',
            periodo_ideal:       props.data !== undefined && props.data !== null ? props.data.periodo_ideal : '',
            observacao:          props.data !== undefined && props.data !== null ? props.data.observacao : '',
            ativo:               props.data !== undefined && props.data !== null ? !!parseInt(props.data.ativo) : true,
            confianca:           props.data !== undefined && props.data !== null ? !!parseInt(props.data.confianca) : true,
            numero:              props.data !== undefined && props.data !== null ? props.data.numero : '',
            complemento:         props.data !== undefined && props.data !== null ? props.data.complemento : '',
            endereco_id:         endereco,
            dia_ideal_id:        dia_ideal,
            periodo_ideal_id:    periodo_ideal,
            estabelecimento_id:  estabelecimento
        },
        enableReinitialize: true,
        validationSchema: isAdmin() ? validarAdmin : validarEstabelecimento,
        onSubmit: values => {
            let data = {
                "nome" : values.nome,
                "telefone_principal": values.telefone_principal && values.telefone_principal !== '' ? values.telefone_principal.replace('(','').replace(')','').replace(' ','').replace('-','').replace(' ','') : '',
                "telefone_secundario": values.telefone_secundario,
                "dia_ideal": values.dia_ideal,
                "periodo_ideal": values.periodo_ideal,
                "observacao": values.observacao,
                "endereco_id": values.endereco_id || (isAdmin()) ? values.endereco_id.value : null,
                "dia_ideal_id": values.dia_ideal_id || (isAdmin()) ? values.dia_ideal_id.value : null,
                "periodo_ideal_id": values.periodo_ideal_id || (isAdmin()) ? values.periodo_ideal_id.value : null,
                "numero": values.numero,
                "complemento": values.complemento,
                "ativo": values.ativo,
                "confianca": 1,//values.confianca,
                "estabelecimento_id": values.estabelecimento_id || (isAdmin()) ? values.estabelecimento_id.value : null,
            }

            if (props.operation !== undefined && props.operation !== null && props.operation === 'alt') {
                props.updateCliente(data, props.data.uuid);
            } else {
                props.insertCliente(data);
            }
        },
    });
    return ( 
        <Form className="forms-sample col-12" onSubmit={formik.handleSubmit}>
            <Card>
                <CardHeader className="bg-maskats text-center">
                    <h4 className="headerTitle">Cadastro de clientes</h4>
                </CardHeader>
                <CardBody>
                    <div>

                        {
                            isAdmin() ? 
                                <FormGroup>
                                    <Label for="estabelecimento_id">* Estabelecimento</Label>
                                    <Combobox
                                        invalid={formik.touched.estabelecimento_id && formik.errors.estabelecimento_id}
                                        valid={formik.touched.estabelecimento_id && !formik.errors.estabelecimento_id}
                                        id="estabelecimento_id"
                                        name="estabelecimento_id"
                                        placeholder={'Selecione um item'}
                                        defaultValue={formik.values.estabelecimento_id}
                                        value={formik.values.estabelecimento_id}
                                        options={props.listaEstabelecimentos}
                                        isMulti={false}
                                        loadingMessage={"Carregando..."}
                                        noOptionsMessage={"Não existem dados cadastrados."}
                                        onChange={formik.setFieldValue}
                                        onBlur={formik.setFieldTouched}
                                        maxMenuHeight={190}
                                    />
                                    {formik.touched.estabelecimento_id && formik.errors.estabelecimento_id ? (
                                        <div className="divError">{formik.errors.estabelecimento_id}</div>
                                    ) : null}
                                </FormGroup>
                            : ""
                        }

                        <FormGroup>
                            <Label for="nome">* Nome</Label>
                            <Input 
                                className="form-control form-control-sm" 
                                id="nome" 
                                name="nome" 
                                type="text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.nome}
                                maxLength={200}
                            />
                            {formik.touched.nome && formik.errors.nome ? (
                                <div className="divError">{formik.errors.nome}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="endereco_id">* Endereço</Label>
                            <Combobox
                                invalid={formik.touched.endereco_id && formik.errors.endereco_id}
                                valid={formik.touched.endereco_id && !formik.errors.endereco_id}
                                id="endereco_id"
                                name="endereco_id"
                                placeholder={'Selecione um item'}
                                defaultValue={formik.values.endereco_id}
                                value={formik.values.endereco_id}
                                options={props.listaEnderecos}
                                isMulti={false}
                                loadingMessage={"Carregando..."}
                                noOptionsMessage={"Não existem dados cadastrados."}
                                onChange={formik.setFieldValue}
                                onBlur={formik.setFieldTouched}
                                maxMenuHeight={190}
                            />
                            {formik.touched.endereco_id && formik.errors.endereco_id ? (
                                <div className="divError">{formik.errors.endereco_id}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="numero">* Número</Label>
                            <Input 
                                className="form-control form-control-sm" 
                                id="numero" 
                                name="numero" 
                                type="number" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.numero}
                            />
                            {formik.touched.numero && formik.errors.numero ? (
                                <div className="divError">{formik.errors.numero}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="complemento">Complemento</Label>
                            <Input 
                                className="form-control form-control-sm" 
                                id="complemento" 
                                name="complemento" 
                                type="text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.complemento}
                                maxLength={200}
                            />
                            {formik.touched.complemento && formik.errors.complemento ? (
                                <div className="divError">{formik.errors.complemento}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="telefone_principal">WhatsApp</Label>
                            <MaskedInput
                                mask={['(', /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]}
                                guide={false}
                                className="form-control form-control-sm"
                                id="telefone_principal"
                                name="telefone_principal"
                                type="text"
                                inputMode="numeric"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.telefone_principal}
                                minLength={16}
                                maxLength={16}
                            />
                            {formik.touched.telefone_principal && formik.errors.telefone_principal ? (
                                <div className="divError">{formik.errors.telefone_principal}</div>
                            ) : null}
                        </FormGroup>
                        
                        <FormGroup>
                            <Label for="telefone_secundario">Telefone secundario</Label>
                            <Input 
                                className="form-control form-control-sm" 
                                id="telefone_secundario" 
                                name="telefone_secundario" 
                                type="text" 
                                inputMode="numeric"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.telefone_secundario}
                                maxLength={200}
                            />
                            {formik.touched.telefone_secundario && formik.errors.telefone_secundario ? (
                                <div className="divError">{formik.errors.telefone_secundario}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="dia_ideal_id">Dia ideal</Label>
                            <Combobox
                                invalid={formik.touched.dia_ideal_id && formik.errors.dia_ideal_id}
                                valid={formik.touched.dia_ideal_id && !formik.errors.dia_ideal_id}
                                id="dia_ideal_id"
                                name="dia_ideal_id"
                                placeholder={'Selecione um item'}
                                defaultValue={formik.values.dia_ideal_id}
                                value={formik.values.dia_ideal_id}
                                options={props.listaDiasIdeais}
                                isMulti={false}
                                loadingMessage={"Carregando..."}
                                noOptionsMessage={"Não existem dados cadastrados."}
                                onChange={formik.setFieldValue}
                                onBlur={formik.setFieldTouched}
                                maxMenuHeight={190}
                            />
                            {formik.touched.dia_ideal_id && formik.errors.dia_ideal_id ? (
                                <div className="divError">{formik.errors.dia_ideal_id}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="periodo_ideal_id">Período ideal</Label>
                            <Combobox
                                invalid={formik.touched.periodo_ideal_id && formik.errors.periodo_ideal_id}
                                valid={formik.touched.periodo_ideal_id && !formik.errors.periodo_ideal_id}
                                id="periodo_ideal_id"
                                name="periodo_ideal_id"
                                placeholder={'Selecione um item'}
                                defaultValue={formik.values.periodo_ideal_id}
                                value={formik.values.periodo_ideal_id}
                                options={props.listaPeriodosIdeais}
                                isMulti={false}
                                loadingMessage={"Carregando..."}
                                noOptionsMessage={"Não existem dados cadastrados."}
                                onChange={formik.setFieldValue}
                                onBlur={formik.setFieldTouched}
                                maxMenuHeight={190}
                            />
                            {formik.touched.periodo_ideal_id && formik.errors.periodo_ideal_id ? (
                                <div className="divError">{formik.errors.periodo_ideal_id}</div>
                            ) : null}
                        </FormGroup>
                        
                        <FormGroup>
                            <Label for="observacao">Observação</Label>
                            <Input 
                                className="form-control form-control-sm" 
                                id="observacao" 
                                name="observacao" 
                                type="textarea"
                                rows={3} 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.observacao}
                                maxLength={200}
                            />
                            {formik.touched.observacao && formik.errors.observacao ? (
                                <div className="divError">{formik.errors.observacao}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Row>
                                <Col md={2} sm={3}>
                                    <Label for="ativo">Ativo</Label>
                                    <br />
                                    <Switch
                                        id="ativo"
                                        name="ativo"
                                        onColor="#28a745"
                                        offColor="#dc3545"
                                        checked={formik.values.ativo}
                                        onChange={()=>formik.setFieldValue('ativo', !formik.values.ativo)}
                                    />
                                </Col>
                                {/* <Col md={2} sm={3}>
                                    <Label for="confianca">Confiança</Label>
                                    <br />
                                    <Switch
                                        id="confianca"
                                        name="confianca"
                                        onColor="#28a745"
                                        offColor="#dc3545"
                                        checked={formik.values.confianca}
                                        onChange={()=>formik.setFieldValue('confianca', !formik.values.confianca)}
                                    />
                                </Col> */}
                            </Row>
                        </FormGroup>
                    </div>
                </CardBody>
                <CardFooter className="text-align-end bg-white">
                    <Link replace to="/cliente">
                        <Button className="mr-2 text-white btn btn-sm btn-secondary btn-fw bd-rd-8" type="button">
                            <i className="fa fa-arrow-left btn-icon-append btn-fs-def"></i>
                            <span className="label-button btn-fs-def">Cancelar</span>
                        </Button>
                    </Link>

                    <Button className="btn btn-sm btn-success btn-fw bd-rd-8" type="submit">
                        <i className="fa fa-check btn-icon-append btn-fs-def"></i>
                        <span className="label-button btn-fs-def">Salvar</span>
                    </Button>
                </CardFooter>
            </Card>
        </Form>
    );
}

class ClienteFormulario extends Component {
    constructor(props){
        super(props);

        this.state = {
            listaEstabelecimentos: [],
            listaEnderecos: [],
            listaDiasIdeais: [],
            listaPeriodosIdeais: []
        };
        
        this.loadingShow   = this.loadingShow.bind(this);
        this.updateCliente = this.updateCliente.bind(this);
        this.insertCliente = this.insertCliente.bind(this);
    }

    async componentDidMount(){
        this.loadingShow(true);
        
        let [listaEstabelecimentos, listaEnderecos, listaDiasIdeais, listaPeriodosIdeais] = await Promise.all([
            getData(`/estabelecimento`, this.props),
            getData(`/endereco`, this.props),
            getData(`/dia-ideal`, this.props),
            getData(`/periodo-ideal`, this.props),
        ]);

        if(listaEstabelecimentos !== null){
            listaEstabelecimentos = listaEstabelecimentos.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }

        if(listaEnderecos !== null){
            listaEnderecos = listaEnderecos.map(function (value) {
                return { value: value.id, label: `${value.logradouro} - ${value.bairro_nome} - ${value.cidade_nome}/${value.estado_nome}`, ativo: value.ativo };
            });
        }

        if(listaDiasIdeais !== null){
            listaDiasIdeais = listaDiasIdeais.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }

        if(listaPeriodosIdeais !== null){
            listaPeriodosIdeais = listaPeriodosIdeais.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }

        this.setState({listaEstabelecimentos, listaEnderecos, listaDiasIdeais, listaPeriodosIdeais});

        this.loadingShow(false);
    }

    loadingShow(value) {
        let { setLoaderShow } = this.props;
        setLoaderShow(value);
    }

    async updateCliente(data, uuid){
        this.loadingShow(true);
        queryClient.removeQueries('clientes');
        await putData(`/cliente/${uuid}`, this.props, data, '../cliente');
        this.loadingShow(false);
    }

    async insertCliente(data){
        this.loadingShow(true);
        queryClient.removeQueries('clientes');
        await postData(`/cliente`, this.props, data, '../cliente');
        this.loadingShow(false);
    }

    render(){
        const { data, operation } = this.props.location;
        const { setResponseModal, enableResponseModal } = this.props;
        return (
            <Fragment>
                <div className="container-scroller">
                    <Navbar/>
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar/>
                        <div className="main-panel">
                            <div className="content-wrapper">
                                <div className="row">
                                    <div className="col-md-12 grid-margin stretch-card">
                                        <Formulario
                                            data={data}
                                            operation={operation}
                                            updateCliente={this.updateCliente}
                                            insertCliente={this.insertCliente}
                                            listaEstabelecimentos={this.state.listaEstabelecimentos}
                                            listaEnderecos={this.state.listaEnderecos}
                                            listaDiasIdeais={this.state.listaDiasIdeais}
                                            listaPeriodosIdeais={this.state.listaPeriodosIdeais}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalResponse 
                    history={this.props.history} 
                    setResponseModal={setResponseModal} 
                    enableResponseModal={enableResponseModal}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        enableLoaderShow: state.enableLoaderShow,
        enableResponseModal: state.enableResponseModal,
    }
};

const mapDispatchToProps = dispatch => ({
    setLoaderShow: enable => dispatch(setLoaderShow(enable)),
    setResponseModal: enable => dispatch(setResponseModal(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClienteFormulario);